import script from "./PlanoMatrizRepository.vue?vue&type=script&lang=js"
export * from "./PlanoMatrizRepository.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__